import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PurchaseOrderLineNarrative } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineNarrativeService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineNarrative,
  PurchaseOrderLineNarrative
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderLineNarrative', $localize`Purchase Order Line Narrative`);
  }
}
